import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { MdArrowRight } from "react-icons/md";
import { CommonNoteLayout } from "../../base/CommonNote";
import { VodLayout } from "../../base/vod";
import { ShareDocumentLayout } from "../../share-document";
import { documentLayoutList, layoutType, PAGING_TYPE, videoLayoutMode } from "../constants";
import LayoutPaging from "./LayoutPaging";
import PinFilm from "./PinFilm";
import RemoteFilm from "./RemoteFilm";
import UserFilm from "./UserFilm";
import VadCoverFilm from "./VadCoverFilm";

const LayoutContainerStyled = styled.div`
    position: ${(props) => (props.expand ? "relative" : "absolute")};
    display: flex;
    max-height: 98px; 
    width: 100%;
    height: ${(props) => (!props.top ? "98px" : "auto")};
    overflow: hidden; 
    justify-content: ${(props) => (!props.top ? "flex-start" : "center")};

    .top {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
        justify-content: center;
    }

    .left {
        display: flex;
        margin: 0 auto 0 0!important;
    }


    & .item {
        width: 172px;
        min-width: ${(props) => (!props.top ? "auto" : "auto")};
        height: 100%;
    }

    & .document_expand {
        cursor: pointer;
        position: absolute;
        left: 146px;
        z-index: 1;
        top: 36px;
        transform: ${(props) => (props.expand ? "rotate(180deg)" : "rotate(0deg)")};

        span {
            &:hover {
                --icon-primary-color: #76acfb!important;
            }
        }
    }
`

export default function PresentHorizontalMode({ type, mode, roomCode, resize }) {
    const [isDocumentExpand, setIsDocumentExpand] = useState(false);
    const [isLeftOpen, setLeftOpen] = useState(true);

    useEffect(() => {
        if (type === layoutType.desktop) setLeftOpen(true);
    }, [type]);

    useEffect(() => {
        setIsDocumentExpand(false);
    }, [isLeftOpen]);

    const setDocumentExpand = () => {
        setIsDocumentExpand(!isDocumentExpand);
    };

    const getLayout = (mode) => {
        switch (mode) {
            case videoLayoutMode.white:
            case videoLayoutMode.document:                
                return (
                    <ShareDocumentLayout 
                        expand={isDocumentExpand} 
                        mobile={false} 
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                        setCanvasMouseMove={null}
                        resize={resize}
                    />
                );
            case videoLayoutMode.note:
                return (
                    <CommonNoteLayout
                        expand={isDocumentExpand} 
                        mobile={false} 
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}

                        roomCode={roomCode} 
                        style={{flex: 1, width:"100%", height: "100%", border: "none"}} 
                    /> 
                );

            case videoLayoutMode.vod:
                return (
                    <VodLayout
                        expand={isDocumentExpand} 
                        mobile={false} 
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                        resize={resize}
                    /> 
                );

        }
    }

    const renderContent = () => {
        if (documentLayoutList.indexOf(mode) !== -1) {
            return (
                <>
                    <LayoutContainerStyled expand={isDocumentExpand} mode={mode} >
                        { isLeftOpen && 
                            <>
                                <span className="document_expand" onClick={setDocumentExpand}>
                                    <MdArrowRight size={24}/>
                                </span>
                                { isDocumentExpand ? <UserFilm /> : <PinFilm onlyOne={true} isStyle={false} /> }  
                            </>
                        }
                    </LayoutContainerStyled>
                    { getLayout(mode) }
                </>
            )
        } else if (mode === videoLayoutMode.voice) {
            return (
                <>
                    <LayoutContainerStyled expand={true} mode={mode} top={true}>
                        <LayoutPaging type={PAGING_TYPE.PREV} isVertical={false}/>
                            <div className="top">
                                <RemoteFilm />
                            </div>
                        <LayoutPaging type={PAGING_TYPE.NEXT} isVertical={false} />
                    </LayoutContainerStyled>
                    <VadCoverFilm />
                </>
            )
        } else if (mode === videoLayoutMode.pin) {
            return (
                <>
                    <LayoutContainerStyled expand={true} mode={mode} top={true}>
                        <LayoutPaging type={PAGING_TYPE.PREV} isVertical={false}/>
                        <div className="top">
                                <RemoteFilm />
                            </div>
                        <LayoutPaging type={PAGING_TYPE.NEXT} isVertical={false} />
                    </LayoutContainerStyled>

                    <div style={{ overflow: "hidden", display: "inline-flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                        <PinFilm onlyOne={false} isStyle={true}/>
                    </div>
                </>
            )
        } else { 
            // seminar mode 
            return (
                <div style={{ overflow: "hidden", display: "inline-flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                    <PinFilm onlyOne={false} isStyle={true}/>
                </div>
            )
        }
    }
    
    return (
        <>
            { renderContent() }
        </>
    )
}